var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-pay-seeklogo.com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.061,
    height: 21.872,
    viewBox: "0 0 55.061 21.872",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3137",
    "data-name": "Path 3137",
    d: "M193.133,19.414v6.415H191.1V9.994h5.392a4.9,4.9,0,0,1,3.5,1.376,4.365,4.365,0,0,1,1.452,3.334,4.418,4.418,0,0,1-1.452,3.359,4.884,4.884,0,0,1-3.485,1.351Zm0-7.476v5.531h3.41a2.658,2.658,0,0,0,2.008-.821,2.694,2.694,0,0,0,.051-3.814l-.051-.051a2.624,2.624,0,0,0-2.008-.833Zm12.994,2.7a5.083,5.083,0,0,1,3.561,1.2,4.281,4.281,0,0,1,1.3,3.309v6.668h-1.945v-1.5h-.088A3.884,3.884,0,0,1,205.6,26.17a4.361,4.361,0,0,1-2.993-1.061,3.349,3.349,0,0,1-1.2-2.652,3.235,3.235,0,0,1,1.275-2.677,5.33,5.33,0,0,1,3.4-1,6.125,6.125,0,0,1,2.98.657v-.467a2.329,2.329,0,0,0-.833-1.793,2.955,2.955,0,0,0-1.957-.745,3.129,3.129,0,0,0-2.7,1.44l-1.793-1.124a4.958,4.958,0,0,1,4.357-2.109ZM203.5,22.508a1.639,1.639,0,0,0,.669,1.326,2.483,2.483,0,0,0,1.579.53,3.23,3.23,0,0,0,2.286-.947,2.982,2.982,0,0,0,1.01-2.235,4.143,4.143,0,0,0-2.652-.758,3.518,3.518,0,0,0-2.071.594,1.805,1.805,0,0,0-.821,1.49Zm18.651-7.514L215.358,30.6h-2.1l2.526-5.455-4.47-10.14h2.21l3.22,7.779h.051l3.144-7.779Z",
    transform: "translate(-167.091 -8.73)",
    fill: "#474747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3138",
    "data-name": "Path 3138",
    d: "M81.726,60.844A11.231,11.231,0,0,0,81.574,59H73v3.5h4.912a4.21,4.21,0,0,1-1.818,2.766v2.273h2.93A8.87,8.87,0,0,0,81.726,60.844Z",
    transform: "translate(-63.905 -51.549)",
    fill: "#474747"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3139",
    "data-name": "Path 3139",
    d: "M16.82,93.149a8.7,8.7,0,0,0,6.024-2.2l-2.93-2.273a5.508,5.508,0,0,1-8.2-2.879H8.7v2.349A9.105,9.105,0,0,0,16.82,93.149Z",
    transform: "translate(-7.725 -74.965)",
    fill: "#474747"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3140",
    "data-name": "Path 3140",
    d: "M4.969,45.521a5.486,5.486,0,0,1,0-3.485V39.7H1.951a9.015,9.015,0,0,0,0,8.158Z",
    transform: "translate(-0.975 -34.686)",
    fill: "#474747"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3141",
    "data-name": "Path 3141",
    d: "M16.82,3.6a4.893,4.893,0,0,1,3.485,1.364L22.894,2.37A8.68,8.68,0,0,0,16.82,0,9.094,9.094,0,0,0,8.7,5.009l3.018,2.349A5.435,5.435,0,0,1,16.82,3.6Z",
    transform: "translate(-7.725 0.004)",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpay);
export default __webpack_public_path__ + "static/media/gpay.f1615effbc05b93a1555c4e5cd75e049.svg";
export { ForwardRef as ReactComponent };